import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_9xek3vwgdx: FaireCollectionEntity = {
  token: "pbc_9xek3vwgdx",
  type: "collection",
  name: "BACK TO SCHOOL",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ce10a493058e3b65a71546b018b02f3382545f8809525a1c4e06cd7e8cd39ad.jpeg",
  itemCount: 141,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.234Z",
    importedBy: "entity-db-import-collections",
  },
};
